import { atom } from "jotai";

export const isMoreMenuOpenAtom = atom(false);

isMoreMenuOpenAtom.debugLabel = "isMoreMenuOpenAtom";
